<template>
  <div class="wg-row ticket-menu" style="height:calc(100vh - 60px);">
    <!-- Sub menu con scelta categorie -->
    <world-sub-menu :selected="pageId" :list="list" @changePage="changePage">
      <template v-slot:content>
        <!-- Tickets list -->
        <tickets-list v-if="pageId === 'ticketsList'"></tickets-list>
      </template>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";
import TicketsList from "../components/TicketsList.vue";

export default {
  data() {
    return {
      loading: false,
      pageId: "ticketsList",
    };
  },
  components: {
    WorldSubMenu,
    TicketsList,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      workSelected: state => state.workSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    list() {
      const list = [];
      list.push({
        id: "ticketsList",
        img: this.$anm22.icons.getWorldIcon("ticket"),
        label: this.$anm22.strLang(
          this.lang,
          "Tickets",
          "Biglietti"
        )
      });
      list.push({
        id: "ticketTypes",
        img: this.$anm22.icons.getWorldIcon("menuSettings"),
        label: this.$anm22.strLang(
          this.lang,
          "Ticket types",
          "Tipologie biglietti"
        )
      });
      list.push({
        id: "ticketAnalytics",
        img: this.$anm22.icons.getWorldIcon("menuAnalytics"),
        label: this.$anm22.strLang(
          this.lang,
          "Analytics",
          "Statistiche"
        )
      });
      return list;
    }
  },
  methods: {
    changePage(elem) {
      if (elem && elem.id == "ticketTypes") {
        this.$router.push('/tickets/types');
      }
      if (elem && elem.id == "ticketAnalytics") {
        this.$router.push('/tickets/analytics');
      }
    }
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, "Tickets", "Tickets") + ' | ANM22 Calendar';
    this.$store.dispatch("works/load", this.$vlf("works"));
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Tickets", "Tickets")
    );
    this.$Progress.finish();
  }
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: block;
  margin: 0 auto;
  padding: 10px;
  width: 150px;
  height: 150px;
}
</style>


<style lang="scss">
.ticket-menu .sub-menu-li .item-icon {
  opacity: 0.6;
}
</style>